export default __webpack_public_path__ + "static/media/Gloves of Fiendish Invocation.d5a10bc3.jpg";